"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const localized_strings_1 = __importDefault(require("localized-strings"));
const locales = new localized_strings_1.default({
    en: {
        totals: {
            total: 'Total',
            totalAmountBeforeTaxes: 'Total excl. VAT',
            vat: 'VAT',
        },
        vat: {
            base: 'Base excl. VAT',
            total: 'VAT amount',
            vat: 'VAT',
        },
        vatPercentage: '{vat}%',
    },
    fr: {
        totals: {
            total: 'Total',
            totalAmountBeforeTaxes: 'Total HT',
            vat: 'TVA',
        },
        vat: {
            base: 'Base HT',
            total: 'Montant TVA',
            vat: 'TVA',
        },
        vatPercentage: '{vat}\xa0%',
    },
});
exports.default = locales;
